import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Clock, Plus, Pencil, Trash2, Save } from "lucide-react";
import { cn } from "../../lib/utils";

const GIORNI_SHORT = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
const COLORI_FASCIA = [
  { value: "#3B82F6", label: "Blu", class: "bg-blue-500" },
  { value: "#10B981", label: "Verde", class: "bg-emerald-500" },
  { value: "#F59E0B", label: "Arancione", class: "bg-amber-500" },
  { value: "#8B5CF6", label: "Viola", class: "bg-violet-500" },
  { value: "#EC4899", label: "Rosa", class: "bg-pink-500" },
  { value: "#6366F1", label: "Indaco", class: "bg-indigo-500" },
];

export const FasceTurnoDialogs = ({
  dialogFasce, onDialogFasceChange,
  dialogEditFascia, onDialogEditFasciaChange,
  fasce, fasciaEdit, fasciaForm, onFasciaFormChange,
  onOpenNuova, onOpenModifica, onSave, onDelete, onToggleGiorno
}) => (
  <>
    <Dialog open={dialogFasce} onOpenChange={onDialogFasceChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Clock className="h-5 w-5 text-primary" />Impostazioni Fasce Turno</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {fasce.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground"><Clock className="h-12 w-12 mx-auto mb-3 opacity-50" /><p>Nessuna fascia turno configurata</p></div>
          ) : (
            fasce.map(fascia => (
              <div key={fascia.id} className="flex items-center justify-between p-3 rounded-lg border bg-card">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-10 rounded-full" style={{ backgroundColor: fascia.colore || "#3B82F6" }} />
                  <div>
                    <p className="font-medium">{fascia.nome}</p>
                    <p className="text-sm text-muted-foreground">{fascia.ora_inizio} - {fascia.ora_fine}</p>
                    {fascia.giorni_attivi && fascia.giorni_attivi.length < 7 && <p className="text-xs text-primary">Solo: {fascia.giorni_attivi.map(g => GIORNI_SHORT[g]).join(", ")}</p>}
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <Button variant="ghost" size="icon" onClick={() => onOpenModifica(fascia)} className="h-8 w-8"><Pencil className="h-4 w-4" /></Button>
                  <Button variant="ghost" size="icon" onClick={() => onDelete(fascia.id)} className="h-8 w-8 text-destructive"><Trash2 className="h-4 w-4" /></Button>
                </div>
              </div>
            ))
          )}
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => onDialogFasceChange(false)} className="flex-1">Chiudi</Button>
          <Button onClick={onOpenNuova} className="flex-1 bg-primary"><Plus className="h-4 w-4 mr-2" />Nuova Fascia</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>

    <Dialog open={dialogEditFascia} onOpenChange={onDialogEditFasciaChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>{fasciaEdit ? "Modifica Fascia" : "Nuova Fascia Turno"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div><Label>Nome *</Label><Input value={fasciaForm.nome} onChange={(e) => onFasciaFormChange({ ...fasciaForm, nome: e.target.value })} placeholder="es. Pranzo, Cena..." className="mt-1" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Ora Inizio *</Label><Input type="time" value={fasciaForm.ora_inizio} onChange={(e) => onFasciaFormChange({ ...fasciaForm, ora_inizio: e.target.value })} className="mt-1" /></div>
            <div><Label>Ora Fine *</Label><Input type="time" value={fasciaForm.ora_fine} onChange={(e) => onFasciaFormChange({ ...fasciaForm, ora_fine: e.target.value })} className="mt-1" /></div>
          </div>
          <div>
            <Label>Giorni attivi</Label>
            <div className="flex gap-1 mt-1">
              {GIORNI_SHORT.map((giorno, idx) => {
                const isActive = fasciaForm.giorni_attivi === null || fasciaForm.giorni_attivi?.includes(idx);
                return (
                  <button key={idx} type="button" onClick={() => onToggleGiorno(idx)} className={cn("flex-1 py-2 text-xs font-medium rounded-md transition-colors", isActive ? "bg-primary text-white" : "bg-muted text-muted-foreground")}>{giorno}</button>
                );
              })}
            </div>
          </div>
          <div>
            <Label>Colore</Label>
            <div className="flex gap-2 mt-2">
              {COLORI_FASCIA.map(c => (
                <button key={c.value} type="button" onClick={() => onFasciaFormChange({ ...fasciaForm, colore: c.value })} className={cn("w-8 h-8 rounded-full transition-all", c.class, fasciaForm.colore === c.value && "ring-2 ring-offset-2 ring-primary scale-110")} />
              ))}
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onDialogEditFasciaChange(false)}>Annulla</Button>
          <Button onClick={onSave} className="bg-primary"><Save className="h-4 w-4 mr-2" />{fasciaEdit ? "Salva" : "Crea"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>
);
